const comParallax = (() => {

  let sW = window.innerWidth;


  let setNum;
  if (sW > 750) {
    setNum = -200;
  } else {
    setNum = -100;
  }


  const fadeElem = document.querySelectorAll('.js-com-parallax-1');
  if (fadeElem.length > 0) {
    gsap.utils.toArray('.js-com-parallax-1').forEach(wrap => {
      const y = wrap.getAttribute('data-y') || setNum;

      gsap.to(wrap, {
        y: y,
        scrollTrigger: {
          trigger: wrap,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0.5,
          // markers: true
        }
      })
    });
  }



  const fadeElem2 = document.querySelectorAll('.js-com-parallax-2');
  if (fadeElem2.length > 0) {

    gsap.utils.toArray('.js-com-parallax-2').forEach(wrap => {
      const y = wrap.getAttribute('data-y') || setNum;

      gsap.to(wrap, {
        y: y,
        scrollTrigger: {
          trigger: wrap,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 5,
          // markers: true
        }
      })
    });
  }



  const fadeElem3 = document.querySelectorAll('.js-com-parallax-3');
  if (fadeElem3.length > 0) {

    gsap.utils.toArray('.js-com-parallax-3').forEach(wrap => {
      const y = wrap.getAttribute('data-y') || 200;

      gsap.to(wrap, {
        y: y,
        scrollTrigger: {
          trigger: wrap,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0.1,
          // markers: true
        }
      })
    });
  }
})();
export default comParallax;